var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _rect, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCargaDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 219.29,
    height: 327.815,
    viewBox: "0 0 219.29 327.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_7126",
    x: 0,
    y: 0,
    width: 178.475,
    height: 214.863,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#303030",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_7126-2",
    x: 97.435,
    y: 77.45,
    width: 96.625,
    height: 113.732,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#303030",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3235",
    "data-name": "Grupo 3235",
    transform: "translate(-96.406 -357)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comprobante",
    transform: "translate(108.406 365)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -8)",
    filter: "url(#Trazado_7126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7126-3",
    "data-name": "Trazado 7126",
    d: "M0,0H153.058V189.719H0Z",
    transform: "matrix(1, -0.01, 0.01, 1, 12, 9.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1859",
    "data-name": "Grupo 1859",
    transform: "translate(13.243 20.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1856",
    "data-name": "Grupo 1856",
    transform: "translate(0.451 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7107",
    "data-name": "Trazado 7107",
    d: "M1100.631,140.836l-42.9.32a.818.818,0,0,1-.827-.808h0a.819.819,0,0,1,.809-.827l42.9-.32a.819.819,0,0,1,.827.808h0A.807.807,0,0,1,1100.631,140.836Z",
    transform: "translate(-1056.9 -139.2)",
    fill: "#7dc133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7109",
    "data-name": "Trazado 7109",
    d: "M1101.031,200.336l-42.9.32a.818.818,0,0,1-.827-.808h0a.819.819,0,0,1,.808-.827l42.9-.32a.819.819,0,0,1,.827.808h0A.807.807,0,0,1,1101.031,200.336Z",
    transform: "translate(-1057.225 -191.479)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7110",
    "data-name": "Trazado 7110",
    d: "M1013.8,287.15l-29.611.226A1.188,1.188,0,0,1,983,286.21h0a1.176,1.176,0,0,1,1.166-1.184l29.611-.226a1.176,1.176,0,0,1,1.185,1.166h0A1.164,1.164,0,0,1,1013.8,287.15Z",
    transform: "translate(-914.715 -257.426)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7111",
    "data-name": "Trazado 7111",
    d: "M1204.9,286.05l-18.218.132a1.188,1.188,0,0,1-1.185-1.166h0a1.176,1.176,0,0,1,1.166-1.184l18.218-.132a1.175,1.175,0,0,1,1.184,1.166h0A1.175,1.175,0,0,1,1204.9,286.05Z",
    transform: "translate(-1079.143 -256.533)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7112",
    "data-name": "Trazado 7112",
    d: "M679.374,288.75l-56.29.414A1.176,1.176,0,0,1,621.9,288h0a1.176,1.176,0,0,1,1.166-1.184l56.29-.414a1.176,1.176,0,0,1,1.185,1.166h0A1.176,1.176,0,0,1,679.374,288.75Z",
    transform: "translate(-621.505 -258.725)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7113",
    "data-name": "Trazado 7113",
    d: "M668.883,332.45l-45.5.338a1.176,1.176,0,0,1-1.184-1.166h0a1.176,1.176,0,0,1,1.166-1.184l45.5-.338a1.176,1.176,0,0,1,1.185,1.166h0A1.188,1.188,0,0,1,668.883,332.45Z",
    transform: "translate(-621.749 -294.209)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7114",
    "data-name": "Trazado 7114",
    d: "M950.983,330.35l-45.5.338a1.176,1.176,0,0,1-1.185-1.166h0a1.175,1.175,0,0,1,1.166-1.184l45.5-.338a1.176,1.176,0,0,1,1.185,1.166h0A1.2,1.2,0,0,1,950.983,330.35Z",
    transform: "translate(-850.811 -292.504)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1857",
    "data-name": "Grupo 1857",
    transform: "translate(0 51.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7115",
    "data-name": "Trazado 7115",
    d: "M1011.8,415.669l-29.611.207A1.176,1.176,0,0,1,981,414.71h0a1.176,1.176,0,0,1,1.166-1.184l29.611-.226a1.176,1.176,0,0,1,1.185,1.166h0A1.2,1.2,0,0,1,1011.8,415.669Z",
    transform: "translate(-913.091 -413.112)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7116",
    "data-name": "Trazado 7116",
    d: "M1202.9,414.65l-18.218.132a1.176,1.176,0,0,1-1.184-1.166h0a1.176,1.176,0,0,1,1.165-1.184l18.218-.132a1.176,1.176,0,0,1,1.185,1.166h0A1.175,1.175,0,0,1,1202.9,414.65Z",
    transform: "translate(-1077.519 -412.3)",
    fill: "#f20000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7117",
    "data-name": "Trazado 7117",
    d: "M677.274,417.35l-56.29.414A1.176,1.176,0,0,1,619.8,416.6h0a1.176,1.176,0,0,1,1.166-1.184l56.29-.414a1.175,1.175,0,0,1,1.184,1.166h0A1.163,1.163,0,0,1,677.274,417.35Z",
    transform: "translate(-619.8 -414.492)",
    fill: "#7dc133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7118",
    "data-name": "Trazado 7118",
    d: "M666.883,460.95l-45.5.338a1.176,1.176,0,0,1-1.184-1.166h0a1.188,1.188,0,0,1,1.166-1.185l45.5-.338a1.176,1.176,0,0,1,1.185,1.166h0A1.176,1.176,0,0,1,666.883,460.95Z",
    transform: "translate(-620.125 -449.895)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7125",
    "data-name": "Trazado 7125",
    d: "M651.382,460.95l-30.391.338c-.44,0-.791-.526-.791-1.166h0c0-.639.352-1.185.779-1.185l30.391-.338c.44,0,.791.526.791,1.166h0C652.161,460.424,651.809,460.95,651.382,460.95Z",
    transform: "translate(-552.29 -449.895)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1858",
    "data-name": "Grupo 1858",
    transform: "translate(0.132 68.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7120",
    "data-name": "Trazado 7120",
    d: "M1012.5,507.55l-29.611.226a1.176,1.176,0,0,1-1.184-1.166h0a1.175,1.175,0,0,1,1.165-1.184l29.612-.226a1.176,1.176,0,0,1,1.185,1.166h0A1.176,1.176,0,0,1,1012.5,507.55Z",
    transform: "translate(-913.791 -505.012)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7121",
    "data-name": "Trazado 7121",
    d: "M1203.6,506.55l-18.218.132a1.176,1.176,0,0,1-1.184-1.166h0a1.175,1.175,0,0,1,1.166-1.184l18.218-.132a1.176,1.176,0,0,1,1.184,1.166h0A1.2,1.2,0,0,1,1203.6,506.55Z",
    transform: "translate(-1078.219 -504.2)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7122",
    "data-name": "Trazado 7122",
    d: "M667.452,509.25l-45.984.414a1.081,1.081,0,0,1-.968-1.166h0a1.088,1.088,0,0,1,.952-1.184l45.984-.414a1.081,1.081,0,0,1,.968,1.166h0A1.09,1.09,0,0,1,667.452,509.25Z",
    transform: "translate(-620.5 -506.392)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7123",
    "data-name": "Trazado 7123",
    d: "M667.483,552.85l-45.5.338a1.176,1.176,0,0,1-1.185-1.166h0a1.176,1.176,0,0,1,1.166-1.185l45.5-.338a1.176,1.176,0,0,1,1.185,1.166h0A1.152,1.152,0,0,1,667.483,552.85Z",
    transform: "translate(-620.744 -541.795)",
    fill: "#a7a9ac"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3234",
    "data-name": "Grupo 3234",
    transform: "translate(145.52 415.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3233",
    "data-name": "Grupo 3233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Captura_de_fachada",
    "data-name": "Captura de fachada",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2796",
    "data-name": "Grupo 2796",
    transform: "translate(41.481 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8635",
    "data-name": "Trazado 8635",
    d: "M306.034,435.935s-11.928-15.15-10.407-17.585,8.86-4.515,8.86-4.515l3.763,4.1Z",
    transform: "translate(-290.803 -282.541)",
    fill: "#fbcfa7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8636",
    "data-name": "Trazado 8636",
    d: "M305.482,280.153c-3.817-6.606-6.56-8.471-11.077-6.754-2.426.922-6.347,4.757-5.11,9.521,1.028,3.957,3.964,9.2,9.217,11.152a6.859,6.859,0,0,0,3.45.363C309.229,293.352,310.052,288.064,305.482,280.153Z",
    transform: "translate(-287.36 -207.073)",
    fill: "#fbcfa7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8637",
    "data-name": "Trazado 8637",
    d: "M308.144,375.874s-17.737-10.561-16.726-13.566,8.363-7.111,8.363-7.111l5.089,3.446Z",
    transform: "translate(-288.6 -251.164)",
    fill: "#dead86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5709",
    "data-name": "Trazado 5709",
    d: "M313.86,217.937a23.174,23.174,0,0,0,1.594,3.647c.244.489.5.961.748,1.452.345.661.676,1.337.962,2.041v-7.1A21.071,21.071,0,0,1,313.86,217.937Zm69.836-86.51H323.988c-7.014,0-12.691,6.008-12.691,13.438V284.971c0,.216,0,.446.014.647v.143c0,.1.014.2.014.3a1.259,1.259,0,0,0,.029.244v.058a4.971,4.971,0,0,0,.087.647,4.277,4.277,0,0,0,.072.46c.029.158.058.3.087.446a.127.127,0,0,0,.014.072c.029.144.058.288.1.431.043.175.1.359.144.531s.1.331.158.5c.014.058.043.115.058.175.058.158.115.3.175.446a14.06,14.06,0,0,0,.935,1.923c.187.33.4.661.618.977a13.37,13.37,0,0,0,1.552,1.825c.144.143.288.273.431.4s.3.262.446.373a7.091,7.091,0,0,0,.762.575c.115.087.23.159.345.23.129.087.272.175.417.262s.287.175.431.244c.158.087.33.175.489.245a.108.108,0,0,0,.072.029c.158.087.317.143.475.216.129.058.262.115.388.158a2.866,2.866,0,0,0,.373.129,2.606,2.606,0,0,0,.359.115c.216.072.431.13.647.187.175.043.345.087.531.115a11.366,11.366,0,0,0,1.193.187,11.567,11.567,0,0,0,1.236.058h59.708c6.683,0,12.159-5.462,12.663-12.375,0-.115.014-.216.014-.331h0c0-.23.014-.46.014-.69V144.865C396.388,137.435,390.711,131.427,383.7,131.427Zm6.87,145.468H317.15V152.929h73.417V276.895ZM313.86,217.937a23.174,23.174,0,0,0,1.594,3.647c.244.489.5.961.748,1.452.345.661.676,1.337.962,2.041v-7.1A21.071,21.071,0,0,1,313.86,217.937Z",
    transform: "translate(-299.26 -131.427)",
    fill: "#e2e0e1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2394",
    "data-name": "Rect\\xE1ngulo 2394",
    d: "M0,0H80.819V123.966H0Z",
    transform: "translate(14.441 21.043)",
    fill: "#fafafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5712",
    "data-name": "Trazado 5712",
    d: "M457.752,150.179a3.263,3.263,0,1,1-3.262-3.262A3.262,3.262,0,0,1,457.752,150.179Z",
    transform: "translate(-374.135 -139.716)",
    fill: "#5b5b5a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5732",
    "data-name": "Trazado 5732",
    d: "M401.077,152.149a1.545,1.545,0,0,1-1.538,1.552H372.221a1.555,1.555,0,0,1-1.553-1.552h0a1.546,1.546,0,0,1,1.539-1.553h27.319a1.546,1.546,0,0,1,1.553,1.539v.014Z",
    transform: "translate(-331.028 -141.684)",
    fill: "#5b5b5a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2795",
    "data-name": "Grupo 2795",
    transform: "translate(28.007 80.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5710",
    "data-name": "Trazado 5710",
    d: "M446.333,413.188s-1.33,9.2-12.771,16.038a45.957,45.957,0,0,1-24.616,6.589,106.005,106.005,0,0,1-7.69-8.965c-5.94-7.92-14.429-5.985-34.413-19.454-5.3-4.652-17.779-10.525-21.2-16.63l54.8-.584c5.947,0,11.828-1.843,14.14-9.516l.122-33.584a27.254,27.254,0,0,1,4.054,3.713,34.819,34.819,0,0,1-.281-5.336c-.085-1.722-.464-3.248-.659-4.982-.293-2.088.378-4.005-.684-5.9a31.588,31.588,0,0,1-2.369-4.872v.317c-2.931-5.849-2.31-20.96.377-24.355a9.4,9.4,0,0,1,3.193-1.485c2.56-.046,2.686.238,3.842.841a26.172,26.172,0,0,1,2.912,7.025c1.062,4.432,2.226,5.128,3.779,7.533,3.015,8.314,5.723,8.859,7.065,14.6.988,4.665,1.267,10.307,3.193,14.669,1.74,7.814,5.015,9.21,4.53,20.022-1.483,7.182-5.772,26.8-5.346,28.869C439.451,403.262,443.6,405.647,446.333,413.188Z",
    transform: "translate(-345.646 -304.18)",
    fill: "#fbcfa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5733",
    "data-name": "Trazado 5733",
    d: "M432.209,429.518c-1.746,8.181-3.126,8.95-6.154,12.345-9.183,10.305-43.354,2.948-53.367,1.093-.916-1.391-5.11-1.545-5.818-2.839l46.441-.379c5.446,0,10.821-3.145,12.633-10.453.025-.183.049-.354.061-.549s.025-.379.036-.574c.021-.153.029-1.312.025-1.466V396.673a15.889,15.889,0,0,1,2.3,1.941C428.35,398.614,433.378,424.047,432.209,429.518Z",
    transform: "translate(-357.003 -353.672)",
    fill: "#ceac91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1629",
    "data-name": "Grupo 1629",
    transform: "translate(92.657 81.606)",
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5734",
    "data-name": "Trazado 5734",
    d: "M487.185,319c.122,6.129.989,10.812,1.992,12.508v2.575c-.7-.465-4.475-4.95-4.472-13.959a24.281,24.281,0,0,1,2.48-10.891c.432-.544,1.2-1.968,1.992-2.277v1.278C488.359,308.946,487.185,316.364,487.185,319Z",
    transform: "translate(-484.705 -306.958)",
    fill: "#c1c1c1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8638",
    "data-name": "Trazado 8638",
    d: "M311.479,339.571s3.771,1.115,3.76,10.091c-.011,8.861-3.96,9.908-3.96,9.908Z",
    transform: "translate(-299.25 -242.803)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8639",
    "data-name": "Trazado 8639",
    d: "M299.8,345.835c-.948-6.729-2.441-9.224-6.74-9.382-2.309-.085-6.853,1.7-7.49,6.036-.529,3.6.06,8.922,3.691,12.345a6.108,6.108,0,0,0,2.7,1.495C298.3,357.96,300.824,353.078,299.8,345.835Z",
    transform: "translate(-285.405 -241.133)",
    fill: "#fbcfa7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8640",
    "data-name": "Trazado 8640",
    d: "M311.133,396.147s2.6.662,2.575,7.114c-.031,6.97-2.728,7.114-2.728,7.114Z",
    transform: "translate(-299.09 -273.076)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8641",
    "data-name": "Trazado 8641",
    d: "M302.095,400.475c-.078-3.634.178-5.191-3.14-5.913-1.782-.388-5.558.41-6.648,3.788-.905,2.807-1.177,7.141,1.174,10.381.479.66,4.676,1.432,6.334.438C301.985,407.868,302.157,403.4,302.095,400.475Z",
    transform: "translate(-288.746 -272.18)",
    fill: "#fbcfa7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8642",
    "data-name": "Trazado 8642",
    d: "M291.713,404.319a25.177,25.177,0,0,1,2.5-5.284c1.361-1.906,3.084-4.455,3.084-4.455s-3.765.691-4.529,2.91A20.635,20.635,0,0,0,291.713,404.319Z",
    transform: "translate(-288.761 -272.238)",
    fill: "#fff5ed"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8643",
    "data-name": "Trazado 8643",
    d: "M304.791,424.56c-.472.716-4.031,1.329-4.676,1.106-3.047-1.053,4.823,2.7,4.823,2.7Z",
    transform: "translate(-292.901 -288.28)",
    fill: "#dead86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8644",
    "data-name": "Trazado 8644",
    d: "M297.2,337.483c.643.489-2.82-1.454-6.087-.258-2.193.8-4.924,4.531-4.968,4.325-.284-1.346,3.475-6.612,8.805-5.213A6.41,6.41,0,0,1,297.2,337.483Z",
    transform: "translate(-285.791 -240.947)",
    fill: "#fff5ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8645",
    "data-name": "Trazado 8645",
    d: "M309.338,275.213c.069-.364,1.69,4.71,1.46,10.295a71.375,71.375,0,0,1-1.2,10.279S306.317,291.142,309.338,275.213Z",
    transform: "translate(-297.527 -208.355)",
    fill: "#c1c1c1",
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2394-2",
    "data-name": "Rect\\xE1ngulo 2394",
    width: 80.819,
    height: 22.362,
    transform: "translate(14.318 123.071)",
    fill: "#5a5a5a"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8646",
    "data-name": "Trazado 8646",
    d: "M508.4,304.871s1.12,5.1,2.909,10.369,4.649,4.714,4.649,4.714a21.817,21.817,0,0,1-2.4-4.707C512.152,311.109,510.86,305.741,508.4,304.871Z",
    transform: "translate(-363.249 -224.235)",
    fill: "#fee4d6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2797",
    "data-name": "Grupo 2797",
    transform: "translate(71.818 129.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_300",
    "data-name": "Elipse 300",
    transform: "translate(17.435 1.013)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_304",
    "data-name": "Elipse 304",
    cx: 5.728,
    cy: 5.728,
    r: 5.728,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_305",
    "data-name": "Elipse 305",
    cx: 5.37,
    cy: 5.37,
    r: 5.37,
    transform: "translate(0.358 0.358)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_301",
    "data-name": "Elipse 301",
    cx: 4.296,
    cy: 4.296,
    r: 4.296,
    transform: "translate(18.867 2.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    "data-name": "close black 24dp",
    transform: "translate(0 2.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8037",
    "data-name": "Trazado 8037",
    d: "M358.607,415.3v7.948h-7.948V415.3Z",
    transform: "translate(-350.659 -415.297)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8038",
    "data-name": "Trazado 8038",
    d: "M358.272,423.411l.5-.5-1.862-1.862,1.862-1.862-.5-.5-1.861,1.862-1.862-1.862-.5.5,1.862,1.862-1.862,1.862.5.5,1.862-1.862Z",
    transform: "translate(-352.472 -417.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sync_black_24dp",
    "data-name": "sync black 24dp",
    transform: "translate(34.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8035",
    "data-name": "Trazado 8035",
    d: "M424.35,418.409l4.833-8.371,8.371,4.833-4.833,8.371Z",
    transform: "translate(-424.35 -410.038)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8036",
    "data-name": "Trazado 8036",
    d: "M431.441,418.781l-1.054-.609.576,2.152,2.188-.639-1.054-.609a2.414,2.414,0,0,1,3.325-.891,2.264,2.264,0,0,1,.849.821l.782-.21a3.229,3.229,0,0,0-4.346-1.351,4.109,4.109,0,0,0-1.267,1.336Zm4.837,2.792a2.415,2.415,0,0,1-3.326.891,2.269,2.269,0,0,1-.849-.821l-.782.21a3.229,3.229,0,0,0,4.346,1.352,3,3,0,0,0,1.293-1.238l1.054.609-.577-2.152-2.214.541Z",
    transform: "translate(-427.58 -413.803)",
    fill: "#fff"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8673",
    "data-name": "Trazado 8673",
    d: "M203.5,523.036c-2.381,3.744-4.493,5.592-6.083,8.719-2.91,5.724-.719,13.006,6.993,16.995,9.473,4.9,25.017,4.685,28.942-.122,3.755-4.6,9.818-15.66,9.818-15.66s4.826-7.888,8.087-9.719a42.181,42.181,0,0,0,11.681-9.934c4.068-4.935,10.335-11.532,13.657-15.694s3.621-7.259,6.436-11.412,9.1-12.928,10.216-15.431,4.922-8.193,5.31-12.1c.2-2-1.432-3.164-3.684-3.33h0a10.359,10.359,0,0,0-7.119,2.458c-4.544,3.779-7.787,6.623-9.475,11.466a30.8,30.8,0,0,1-4.221,7.252c-2.479,3.321-5.191,6.034-5.991,5.493-1.384-.938,3.143-14.292,6.494-19.621s11.236-17.508,13.741-21.88,2.683-6.378,4.2-10.154,4.332-11.9,3.36-13.856a5.217,5.217,0,0,0-2.67-2.237c-1.9-.745-4.364-.451-6.156,3.016-2.99,5.782-5.511,13.1-7.758,15.978s-5.2,7.658-7.608,11.044a17.179,17.179,0,0,1-4.077,4.429.047.047,0,0,0-.014-.014,9.318,9.318,0,0,0-4.921-1.8,7.349,7.349,0,0,0-4.4,1.232c-4.776,3.09-5.477,3.542-5.477,3.542a3.185,3.185,0,0,0-1.633-.517h0c-1.319-.106-3.461.252-6.539,2.318-5.675,3.815-5.841,3.987-7.887,4.8s-8.75,1.843-11.474,4.458-4.606,5.047-5.522,8.677-7.187,33.955-8.71,36.667S205.76,519.483,203.5,523.036Z",
    transform: "translate(-196.181 -282.593)",
    fill: "#fbcfa7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8674",
    "data-name": "Trazado 8674",
    d: "M261.2,597.287c-2.03,2.487-7.17,3.744-12.971,3.7,3.574-4.894,10.159-13.313,12.944-17.654,7.607-11.857,17.053-23.979,20.071-25.066,3.8-1.37,13.943-12.672,17.863-14.464s8.639-13.043,10.045-14.934c1.8-2.418,4.829-5.255,6.382-6.027s3.332-6.2,3.142-6.934-3.05-1.67-1.885-4.873a11.289,11.289,0,0,1,6.119-6.167s3.691.472,3.494,2.468c-.387,3.908-4.188,9.6-5.31,12.1s-7.4,11.277-10.216,15.431-3.114,7.249-6.436,11.412-9.589,10.758-13.657,15.694a42.184,42.184,0,0,1-11.681,9.934c-3.261,1.831-8.087,9.719-8.087,9.719S264.96,592.685,261.2,597.287Z",
    transform: "translate(-224.034 -331.252)",
    fill: "#ceac91"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8675",
    "data-name": "Trazado 8675",
    d: "M341.974,470.772c-1.058,5.153-1.639,10.962-.966,12.807.641,1.758,2.7,1.44,3.032,3.008s-1.043,5.6-1.492,6.312c-.435.692.061,1.713,3.1-4.057,2.567-4.868,3.207-4.5,4.751-7.18a9.308,9.308,0,0,0,.991-2.421c-2.479,3.321-5.191,6.034-5.991,5.493-1.384-.938,3.143-14.292,6.494-19.621s11.236-17.508,13.741-21.88,2.683-6.378,4.2-10.154,4.332-11.9,3.36-13.856c-.387-.788-1.1.809-2.11,2.205s-1.057,2.628-2.234,6.435a25.762,25.762,0,0,1-3.53,7.381,9.777,9.777,0,0,1-6.753,4.236c-2.111.491,1.847,2.675,1.78,4.1-.119,2.554-8.273,14.587-10.97,16.763S343.031,465.619,341.974,470.772Z",
    transform: "translate(-273.522 -285.312)",
    fill: "#ceac91"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8676",
    "data-name": "Trazado 8676",
    d: "M315.931,494.113c2.512-1.163,7.663-7.245,7.663-7.245a.048.048,0,0,0-.014-.014,9.523,9.523,0,0,0-3.753-1.658,11.271,11.271,0,0,1-2.542,5.113c-1.17.98-9.686,5.383-11.924,7.123-1.275.992-5.828,8.7-4.158,8.473.523-.07,6.269-6.188,8.4-7.982A24.832,24.832,0,0,1,315.931,494.113Z",
    transform: "translate(-252.183 -320.725)",
    fill: "#ceac91"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8677",
    "data-name": "Trazado 8677",
    d: "M286.805,503.4c.976-1.149,3.835-1.875,6.368-2.815s7.85-5.931,7.85-5.931a2.781,2.781,0,0,0-1.113-.443,12.4,12.4,0,0,1-1.561,1.339c-1.824,1.329-5.379,2.937-8.31,4.5C286.141,502.13,285.829,504.55,286.805,503.4Z",
    transform: "translate(-244.423 -325.55)",
    fill: "#ceac91"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8678",
    "data-name": "Trazado 8678",
    d: "M406.261,505.427c-.352,2.728-4.175,10.094-6.015,9.181s-5-2.242-4.581-5.02,4.974-6.333,5.928-7.029C403.371,501.261,406.523,503.4,406.261,505.427Z",
    transform: "translate(-302.902 -329.804)",
    fill: "#fee4d6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8679",
    "data-name": "Trazado 8679",
    d: "M400.093,412.058c.564.877,1.079,2.5-.085,5.293-1.708,4.094-4.444,3.482-5.871,2.95s-2.9-1.667-.55-6.385c1.268-2.54,2.383-3,3.447-3.115A4,4,0,0,1,400.093,412.058Z",
    transform: "translate(-301.149 -280.911)",
    fill: "#fee4d6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "comprobante-2",
    "data-name": "comprobante",
    transform: "translate(60.321 27.372)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -109.44, -85.45)",
    filter: "url(#Trazado_7126-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7126-4",
    "data-name": "Trazado 7126",
    d: "M0,0H71.958V89.194H0Z",
    transform: "matrix(1, -0.01, 0.01, 1, 109.44, 85.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1859-2",
    "data-name": "Grupo 1859",
    transform: "translate(6.226 9.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1856-2",
    "data-name": "Grupo 1856",
    transform: "translate(0.212 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7107-2",
    "data-name": "Trazado 7107",
    d: "M1077.459,139.969l-20.171.15a.385.385,0,0,1-.389-.38h0a.385.385,0,0,1,.38-.389l20.171-.15a.385.385,0,0,1,.389.38h0A.379.379,0,0,1,1077.459,139.969Z",
    transform: "translate(-1056.9 -139.2)",
    fill: "#7dc133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7109-2",
    "data-name": "Trazado 7109",
    d: "M1077.86,199.469l-20.171.15a.385.385,0,0,1-.389-.38h0a.385.385,0,0,1,.38-.389l20.171-.15a.385.385,0,0,1,.389.38h0A.379.379,0,0,1,1077.86,199.469Z",
    transform: "translate(-1057.265 -195.305)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7110-2",
    "data-name": "Trazado 7110",
    d: "M997.478,285.9l-13.922.106a.559.559,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l13.921-.106a.553.553,0,0,1,.557.548h0A.547.547,0,0,1,997.478,285.9Z",
    transform: "translate(-950.897 -271.93)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7111-2",
    "data-name": "Trazado 7111",
    d: "M1194.622,284.8l-8.565.062a.559.559,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l8.565-.062a.553.553,0,0,1,.557.548h0A.553.553,0,0,1,1194.622,284.8Z",
    transform: "translate(-1135.497 -270.928)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7112-2",
    "data-name": "Trazado 7112",
    d: "M648.921,287.5l-26.464.194a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l26.464-.194a.553.553,0,0,1,.557.548h0A.553.553,0,0,1,648.921,287.5Z",
    transform: "translate(-621.714 -273.389)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7113-2",
    "data-name": "Trazado 7113",
    d: "M644.147,331.2l-21.39.159a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l21.391-.159a.553.553,0,0,1,.557.548h0A.558.558,0,0,1,644.147,331.2Z",
    transform: "translate(-621.988 -313.226)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7114-2",
    "data-name": "Trazado 7114",
    d: "M926.247,329.1l-21.39.159a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l21.39-.159a.553.553,0,0,1,.557.548h0A.564.564,0,0,1,926.247,329.1Z",
    transform: "translate(-879.153 -311.312)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1857-2",
    "data-name": "Grupo 1857",
    transform: "translate(0 24.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7115-2",
    "data-name": "Trazado 7115",
    d: "M995.478,414.414l-13.921.1a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l13.921-.106a.553.553,0,0,1,.557.548h0A.566.566,0,0,1,995.478,414.414Z",
    transform: "translate(-949.073 -413.212)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7116-2",
    "data-name": "Trazado 7116",
    d: "M1192.622,413.4l-8.565.062a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l8.565-.062a.553.553,0,0,1,.557.548h0A.553.553,0,0,1,1192.622,413.4Z",
    transform: "translate(-1133.675 -412.3)",
    fill: "#f20000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7117-2",
    "data-name": "Trazado 7117",
    d: "M646.821,416.1l-26.464.195a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557L646.812,415a.553.553,0,0,1,.557.548h0A.547.547,0,0,1,646.821,416.1Z",
    transform: "translate(-619.8 -414.761)",
    fill: "#7dc133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7118-2",
    "data-name": "Trazado 7118",
    d: "M642.147,459.7l-21.39.159a.553.553,0,0,1-.557-.548h0a.558.558,0,0,1,.548-.557l21.39-.159a.553.553,0,0,1,.557.548h0A.553.553,0,0,1,642.147,459.7Z",
    transform: "translate(-620.165 -454.508)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7125-2",
    "data-name": "Trazado 7125",
    d: "M634.86,459.7l-14.288.159c-.207,0-.372-.247-.372-.548h0c0-.3.165-.557.366-.557l14.288-.159c.207,0,.372.248.372.548h0C635.226,459.457,635.061,459.7,634.86,459.7Z",
    transform: "translate(-588.273 -454.508)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1858-2",
    "data-name": "Grupo 1858",
    transform: "translate(0.062 32.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7120-2",
    "data-name": "Trazado 7120",
    d: "M996.178,506.3l-13.921.106a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l13.922-.106a.553.553,0,0,1,.557.548h0A.553.553,0,0,1,996.178,506.3Z",
    transform: "translate(-949.774 -505.112)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7121-2",
    "data-name": "Trazado 7121",
    d: "M1193.322,505.3l-8.565.062a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l8.565-.062a.553.553,0,0,1,.557.548h0A.564.564,0,0,1,1193.322,505.3Z",
    transform: "translate(-1134.375 -504.2)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7122-2",
    "data-name": "Trazado 7122",
    d: "M642.574,508l-21.619.194a.508.508,0,0,1-.455-.548h0a.511.511,0,0,1,.448-.557l21.619-.194a.508.508,0,0,1,.455.548h0A.513.513,0,0,1,642.574,508Z",
    transform: "translate(-620.5 -506.661)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7123-2",
    "data-name": "Trazado 7123",
    d: "M642.747,551.6l-21.39.159a.553.553,0,0,1-.557-.548h0a.553.553,0,0,1,.548-.557l21.39-.159a.553.553,0,0,1,.557.548h0A.542.542,0,0,1,642.747,551.6Z",
    transform: "translate(-620.773 -546.408)",
    fill: "#a7a9ac"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargaDoc);
export default __webpack_public_path__ + "static/media/cargaDoc.ac9607f8222dc08b973cddd73d65acb4.svg";
export { ForwardRef as ReactComponent };